import { formatCurrencyRound } from '@utils/formatters.util';
import { Tier } from './types';
import cx from '@utils/cx.util';

type DiscountProgressItemProps = {
  isActive: boolean;
} & Tier;

export const DiscountProgressItem = ({ threshold, gift, isActive }: DiscountProgressItemProps) => {
  return (
    <div className='tw-flex tw-w-[65px] tw-flex-col tw-items-center tw-gap-2'>
      <span
        className={cx(
          'tw-flex tw-h-[30px] tw-w-[30px] tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-white tw-text-center tw-text-2xs tw-font-bold tw-text-white',
          {
            'tw-bg-[#d1d1d1]': !isActive,
            'tw-bg-[#5F8047]': isActive,
          }
        )}>
        {formatCurrencyRound(threshold)}
      </span>
      {gift && (
        <p className='tw-mb-0 tw-text-center tw-text-[11px] tw-font-bold tw-uppercase tw-leading-none tw-text-body'>
          {gift}
        </p>
      )}
    </div>
  );
};
